export default {
  'meta': {
    'langName': 'THAI',
    'lang': 'ไทย'
  },
  'title': 'ประกาศเรียกคืนสินค้า: สกู๊ตเตอร์ไฟฟ้า B\'TWIN รุ่น SD500E หรือ MD500E',
  'description': 'เรียน คุณลูกค้าที่เคารพ\n\nท่านได้ซื้อสกู๊ตเตอร์ไฟฟ้าแบรนด์ B\'TWIN รุ่น SD 500E หรือ MD500E และเราขอขอบพระคุณเป็นอย่างยิ่งสำหรับการสั่งซื้อของคุณ\n\nเนื่องจากความปลอดภัยของคุณคือสิ่งสำคัญที่สุดสำหรับเรา โปรดอ่านข้อมูลต่อไปนี้\n\nแม้ว่าเราจะมีขั้นตอนการควบคุมคุณภาพที่เข้มงวด แต่เราได้ตรวจพบข้อบกพร่องด้านความปลอดภัยในสกู๊ตเตอร์ไฟฟ้าแบรนด์ B\'TWIN รุ่น SD500E และ MD500E โดยการใช้งานอย่างหนักอาจทำให้เกิดรอยร้าวบริเวณรอยต่อระหว่างโครงรถ (เฟรม) และคอพวงมาลัย ข้อบกพร่องนี้อาจทำให้รอยต่อดังกล่าวหัก ซึ่งส่งผลให้ผู้ใช้งานเสี่ยงต่อการเกิดอุบัติเหตุพลัดตกได้\n\nเราขอให้คุณตอบคำถามดังต่อไปนี้ เพื่อให้เราสามารถดำเนินการเสนอแนวทางแก้ไขเพื่อความปลอดภัยสำหรับสินค้าของคุณได้\n\nเราต้องขออภัยในความไม่สะดวกที่เกิดขึ้น และขอขอบพระคุณที่ไว้วางใจเรา\n\nดีแคทลอน',
  'emailConfirmation': {
    'title': ' รบกวนช่วยยืนยันที่อยู่อีเมลและประเทศที่ท่านอาศัยอยู่'
  },
  'fields': {
    'country': 'ประเทศ',
    'address': 'อีเมล',
    'email': 'อีเมล',
    'phonePrefix': 'รหัสโทรศัพท์ประเทศ',
    'phone': 'เบอร์โทรศัพท์',
    'validations': {
      'phoneOrEmail': 'กรุณาระบุที่อยู่อีเมลหรือหมายเลขโทรศัพท์อย่างน้อยหนึ่งอย่าง',
      'email': 'โปรดระบุที่อยู่อีเมลที่ถูกต้อง',
      'phone': 'โปรดระบุเบอร์โทรศัพท์ที่ถูกต้อง',
      'selectAddress': 'กรุณาเลือกที่อยู่ที่สมบูรณ์จากรายการ (บ้านเลขที่, ชื่อถนน และอำเภอ/เขต)',
      'incompleteAddress': 'ที่อยู่จะต้องประกอบไปด้วย เลขที่, ชื่อถนน และอำเภอ/เขต/เมือง'
    },
    'firstName': 'นามสกุล',
    'lastName': 'ชื่อ',
    'deliveryAddress': 'ที่อยู่สำหรับจัดส่งพัสดุ',
    'additionalAddress': 'รายละเอียดที่อยู่เพิ่มเติม',
    'city': 'จังหวัด',
    'zip': 'รหัสไปรษณีย์',
    'readConfirmation': 'ข้าพเจ้าขอรับรองว่าข้อมูลการติดต่อของข้าพเจ้าถูกต้อง รับทราบว่าได้อ่านเงื่อนไขที่ระบุไว้ และตกลงที่จะปฏิบัติตามเงื่อนไขดังกล่าว',
    'choose': 'เลือก',
    'required': 'กรุณากรอกข้อมูลในช่องนี้',
    'deliveryAddressHelp': 'กรุณาพิมพ์อย่างน้อยบ้านเลขที่และชื่อถนน จากนั้นเลือกที่อยู่จากตัวเลือกที่แนะนำ',
    'streetOnlyHint': 'กรุณากรอกบ้านเลขที่และชื่อถนนของคุณ จากนั้นเลือกที่อยู่ที่สมบูรณ์จากรายการ'
  },
  'ownerCheck': {
    'title': 'ท่านยังคงเป็นเจ้าของสกู๊ตเตอร์ไฟฟ้า B\'TWIN รุ่น SD500E และ MD500E (ตั้งแต่หนึ่งคันขึ้นไป) อยู่หรือไม่?'
  },
  'yes': 'ใช่',
  'no': 'ไม่',
  'ownerChanged': {
    'title': 'ท่านมีข้อมูลการติดต่อของเจ้าของคนปัจจุบันหรือไม่?',
    'confirmation': 'เรียน คุณลูกค้าที่เคารพ,\n\nขอขอบพระคุณที่ให้ความร่วมมือในการดำเนินการด้านคุณภาพในครั้งนี้\n\nเราต้องขออภัยในความไม่สะดวกที่เกิดขึ้น และขอขอบพระคุณที่ไว้วางใจเรา\n\nดีแคทลอน '
  },
  'recall': {
    'title': 'กรุณาระบุจำนวนของสกู๊ตเตอร์ไฟฟ้า B\'TWIN รุ่น SD500E และ MD500E',
    'descriptionSd500': 'สกู๊ตเตอร์ไฟฟ้า  SD500E',
    'descriptionEmd500e': 'สกู๊ตเตอร์ไฟฟ้า  MD500E',
    'modelNumberHelp': 'ท่านสามารถดูหมายเลขรุ่น (SD500E หรือ MD500E) ได้ที่บริเวณใต้สกู๊ตเตอร์ของคุณ ดังภาพด้านล่าง',
    'quantity': 'จำนวน',
    'confirmation': 'ขอขอบพระคุณที่ให้ข้อมูลผ่านแบบฟอร์มนี้ ทางเราได้บันทึกคำขอของท่านเรียบร้อยแล้ว\n\nทางเราจะแจ้งให้ท่านทราบภายในเวลาไม่เกิน 20 วัน เกี่ยวกับกำหนดการที่ท่านจะสามารถเริ่มดำเนินการซ่อมแซมได้\n\nขอแสดงความนับถือ,\n\nดีแคทลอน'
  },
  'repair': {
    'description': 'เราขอความกรุณาให้ท่านหยุดใช้งานสกู๊ตเตอร์ดังกล่าวชั่วคราว\n\nชุดอุปกรณ์ซ่อมแซมพร้อมคู่มือการใช้งานจะถูกจัดส่งไปยังบ้านของท่าน เพื่อให้ท่านสามารถล็อกสกู๊ตเตอร์ได้อย่างปลอดภัย ชุดอุปกรณ์นี้จะถูกจัดส่งให้ฟรีโดยไม่มีค่าใช้จ่ายใด ๆ ทั้งสิ้น และสามารถประกอบเองได้อย่างรวดเร็วและง่ายดาย\n\nหลังจากที่เราได้รวบรวมข้อมูลของท่านเรียบร้อยแล้ว เราจะติดต่อกลับภายในระยะเวลาไม่เกิน 20 วัน เพื่อยืนยันกำหนดการส่งมอบชุดอุปกรณ์ซ่อมแซมดังกล่าว ทั้งนี้ ขอให้ท่านมั่นใจว่าเราจะพยายามอย่างเต็มที่เพื่อลดความล่าช้าและสร้างความพึงพอใจสูงสุดให้แก่ท่าน',
    'kitLabel': 'ชุดอุปกรณ์ซ่อมแซมแบบครบชุด ',
    'docLabel': 'คู่มือการซ่อมแซม',
    'callToAction': 'คลิกที่นี่เพื่อขอรับชุดอุปกรณ์ซ่อมแซมโดยไม่มีค่าใช้จ่าย',
    'infoConfirmation': 'โปรดตรวจสอบความถูกต้องของข้อมูล',
    'validateConfirmation': 'ยืนยัน',
    'backConfirmation': 'กลับ'
  },
  'repairRequest': {
    'title': 'โปรดระบุข้อมูลต่อไปนี้เพื่อรับชุดอุปกรณ์ซ่อมแซมของคุณ'
  },
  'form': {
    'submit': 'ต่อไป'
  },
  'status': 'Translation validated by COUNTRY'
} as const
